import { ModelType } from 'models/ModelType';
import { getDefaultCSSColor } from '@ardoq/color-helpers';
import { APIComponentType } from '@ardoq/api-types';

export const getColor = (node: ModelType | APIComponentType) =>
  node.color || getDefaultCSSColor(node.level);
